import { render, staticRenderFns } from "./CreatePostActions.vue?vue&type=template&id=1e2b8c58&"
import script from "./CreatePostActions.vue?vue&type=script&lang=js&"
export * from "./CreatePostActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports